import React, { useContext } from 'react';
import { GlobalContext } from '../../context/GlobalContext';
import avatar from '../../img/avatar.svg';

function Header() {
    const { state } = useContext(GlobalContext);
    const { userData } = state;

    return (
        <header className='z-40 ml-10 mt-5 flex h-16 w-11/12 items-center justify-between rounded-lg bg-white p-2 shadow-md'>
            <div className='ml-6 block lg:hidden'>
                <button className='text-md flex items-center rounded-full bg-white p-2 text-gray-500 shadow'>
                    <svg
                        width={20}
                        height={20}
                        className='text-gray-400'
                        fill='currentColor'
                        viewBox='0 0 1792 1792'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path d='M1664 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z'></path>
                    </svg>
                </button>
            </div>
            <div className='relative z-20 flex h-full flex-col justify-end px-3 md:w-full'>
                <div className='relative flex w-full items-center justify-end space-x-4 p-1'>
                    <span className='h-8 w-1 rounded-lg bg-gray-200'></span>
                    <p className='text-md flex items-center text-gray-500 dark:text-white'>
                        {userData.name}
                    </p>
                    <div className='relative block'>
                        <img
                            alt='profil'
                            src={
                                userData.image_url.length < 10
                                    ? avatar
                                    : userData.image_url
                            }
                            className='mx-auto h-10 w-10 rounded-full object-cover '
                        />
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;
